import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MahilaMandiDealsNearby from './MahilaMandiDealsNearby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInfoCircle, faVideo, faImages, faMapMarkerAlt, faHistory,
  faRobot, faUserTie, faPhone
} from '@fortawesome/free-solid-svg-icons';

const dummyMahilaMandiProducts = [
  {
    id: 1,
    title: "Homemade Mango Pickle",
    brief: "Spicy and tangy mango pickle crafted by local women artisans.",
    category: "Pickles & Preserves",
    location: "Mumbai",
    hasOffer: true,
    image: "/api/downloads/home-products/pickle.jpg",
  },
  {
    id: 2,
    title: "Handmade Lavender Soap",
    brief: "Natural lavender-infused soap for gentle skincare.",
    category: "Handmade Soaps",
    location: "Pune",
    hasOffer: false,
    image: "/api/downloads/home-products/soap.jpg",
  },
  {
    id: 3,
    title: "Artisan Oatmeal Cookies",
    brief: "Freshly baked, wholesome oatmeal cookies with love.",
    category: "Baked Goods",
    location: "Delhi",
    hasOffer: true,
    image: "/api/downloads/home-products/cookies.jpg",
  },
  {
    id: 4,
    title: "Embroidered Cotton Handkerchiefs",
    brief: "Delicate hand-embroidered handkerchiefs from skilled women weavers.",
    category: "Textiles",
    location: "Jaipur",
    hasOffer: false,
    image: "/api/downloads/home-products/handkerchief.jpg",
  },
];

const categories = [
  "Pickles & Preserves", "Handmade Soaps", "Baked Goods", "Jewelry",
  "Textiles", "Candles", "Pottery", "Herbal Teas"
];

const MahilaMandiNearbyDeals = () => {
  const [filters, setFilters] = useState({
    category: '',
    location: '',
    keywords: '',
    hasOffer: false,
  });
  const [results, setResults] = useState(dummyMahilaMandiProducts);
  const [nearbyClicked, setNearbyClicked] = useState(false);
  const navigate = useNavigate();

  const handleSearch = () => {
    const filtered = dummyMahilaMandiProducts.filter(product =>
      (!filters.category || product.category === filters.category) &&
      (!filters.location || product.location.toLowerCase().includes(filters.location.toLowerCase())) &&
      (!filters.hasOffer || product.hasOffer) &&
      (!filters.keywords || product.title.toLowerCase().includes(filters.keywords.toLowerCase()))
    );
    setResults(filtered);
  };

  // Initialize with all products on mount
  useEffect(() => {
    handleSearch();
  }, []);

  return (
    <div className="w-full p-4 sm:p-6 max-w-6xl mx-auto bg-black text-white border border-green-500 rounded shadow">
      <h2 className="text-xl sm:text-lg lg:text-2xl font-bold mb-2 text-yellow-200 text-center sm:text-left">
        Explore Women-Led Homemade Products Nearby Availability
      </h2>

      {/* Filters */}
      <div className="flex flex-col lg:flex-row gap-4 mb-4 sm:mb-2">
        {/* Category Dropdown */}
        <select
          onChange={(e) => setFilters({ ...filters, category: e.target.value })}
          className="w-full border text-black p-2 rounded h-10"
        >
          <option value="">Select Category</option>
          {categories.map(cat => (
            <option key={cat} value={cat}>{cat}</option>
          ))}
        </select>

        {/* Location Input */}
        <input
          type="text"
          placeholder="Location"
          onChange={(e) => setFilters({ ...filters, location: e.target.value })}
          className="w-full border p-2 rounded h-10"
        />

        {/* Keywords Input */}
        <input
          type="text"
          placeholder="Keywords"
          onChange={(e) => setFilters({ ...filters, keywords: e.target.value })}
          className="w-full h-10 border p-2 rounded"
        />
      </div>
      <div className="flex flex-row justify-center gap-4 sm:space-x-4 sm:space-y-0 mb-2">
        {/* Offers Only Checkbox */}
        <label className="flex items-center justify-start space-x-2 text-white mt-0 lg:mt-2">
          <input
            type="checkbox"
            onChange={(e) => setFilters({ ...filters, hasOffer: e.target.checked })}
            className="rounded"
          />
          <span className="text-sm">Show Offers Only</span>
        </label>
      </div>

      {/* Search & Nearby Buttons */}
      <div className="flex flex-row justify-center gap-4 mb-2">
        <button 
          onClick={handleSearch}
          className="w-40 bg-blue-600 text-white px-2 py-2 rounded-full hover:bg-blue-700 transition"
        >
          Search
        </button>

        <button 
          onClick={() => setNearbyClicked(!nearbyClicked)}
          className="w-40 bg-green-600 text-white px-2 py-2 rounded-full hover:bg-green-700 transition"
        >
          Nearby Deals
        </button>
      </div>

      {/* Results */}
      <div className="mt-6 sm:mt-8 space-y-4">
        {results.length === 0 ? (
          <p className="text-center text-gray-300">No products found. Try adjusting your filters.</p>
        ) : (
          results.map(product => (
            <div key={product.id} className="bg-black border border-green-500 p-3 sm:p-4 rounded shadow-md flex flex-col md:flex-row gap-3 sm:gap-4">
              <img src={product.image} alt={product.title} className="w-full md:w-40 h-28 sm:h-32 object-cover rounded" />
              
              <div className="flex-1">
                <h3 className="text-base sm:text-lg lg:text-xl font-bold text-yellow-200">{product.title}</h3>
                <p className="text-white mb-3 sm:mb-4 text-sm">{product.brief}</p>

                {/* Action Grid */}
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 text-xs sm:text-sm place-items-center">
                  <button
                    onClick={() => {
                      // Dummy data for View Details
                      alert(`Product Details:\nTitle: ${product.title}\nDescription: ${product.brief}\nCategory: ${product.category}\nLocation: ${product.location}\nOffer: ${product.hasOffer ? 'Yes' : 'No'}`);
                    }}
                    className="flex items-center justify-start gap-1 sm:gap-2 bg-blue-500 hover:bg-blue-600 text-white px-2 sm:px-3 py-1 sm:py-2 rounded transition-all duration-200 whitespace-nowrap"
                  >
                    <FontAwesomeIcon icon={faInfoCircle} className="text-xs sm:text-sm" />
                    <span className="hidden sm:inline">View Details</span>
                    <span className="sm:hidden text-xs">View</span>
                  </button>
                  <button
                    onClick={() => navigate("/wTube")}
                    className="flex items-center justify-start gap-1 sm:gap-2 bg-indigo-500 hover:bg-indigo-600 text-white px-2 sm:px-3 py-1 sm:py-2 rounded transition-all duration-200 whitespace-nowrap"
                  >
                    <FontAwesomeIcon icon={faVideo} className="text-xs sm:text-sm" />
                    <span className="hidden sm:inline">Video</span>
                    <span className="sm:hidden text-xs">Video</span>
                  </button>
                  <button
                    onClick={() => {
                      // Dummy data for Photos
                      alert(`Photos for ${product.title}:\nGallery includes 5 high-res images:\n1. Product close-up\n2. Ingredients list\n3. Packaging\n4. Artisan at work\n5. Customer review photo`);
                    }}
                    className="flex items-center justify-start gap-1 sm:gap-2 bg-green-500 hover:bg-green-600 text-white px-2 sm:px-3 py-1 sm:py-2 rounded transition-all duration-200 whitespace-nowrap"
                  >
                    <FontAwesomeIcon icon={faImages} className="text-xs sm:text-sm" />
                    <span className="hidden sm:inline">Photos</span>
                    <span className="sm:hidden text-xs">Photos</span>
                  </button>
                  <button
                    onClick={() => {
                      const address = `123 Women Artisan Street, ${product.location}, India`;
                      const mapUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
                      window.open(mapUrl, '_blank');
                    }}
                    className="flex items-center justify-start gap-1 sm:gap-2 bg-yellow-500 hover:bg-yellow-600 text-white px-2 sm:px-3 py-1 sm:py-2 rounded transition-all duration-200 whitespace-nowrap"
                  >
                    <FontAwesomeIcon icon={faMapMarkerAlt} className="text-xs sm:text-sm" />
                    <span className="hidden sm:inline">Locality</span>
                    <span className="sm:hidden text-xs">Locality</span>
                  </button>
                  <button
                    onClick={() => {
                      // Dummy data for History
                      alert(`History for ${product.title}:\nCreated on: 2024-05-15\nArtisan: Priya Sharma\nProduction batches: 3 (Total 150 units)\nPrevious sales: 120 units\nLast updated: 2024-10-20`);
                    }}
                    className="flex items-center justify-start gap-1 sm:gap-2 bg-red-500 hover:bg-red-600 text-white px-2 sm:px-3 py-1 sm:py-2 rounded transition-all duration-200 whitespace-nowrap"
                  >
                    <FontAwesomeIcon icon={faHistory} className="text-xs sm:text-sm" />
                    <span className="hidden sm:inline">History</span>
                    <span className="sm:hidden text-xs">History</span>
                  </button>
                  <button
                    onClick={() => {
                      // Dummy data for Ask AI
                      alert(`AI Response for ${product.title}:\nQ: What are the ingredients?\nA: Natural mango, spices, and homemade recipe by women artisans.\nQ: Shelf life?\nA: 6 months in cool, dry place.\nAsk more questions via chat!`);
                    }}
                    className="flex items-center justify-start gap-1 sm:gap-2 bg-purple-500 hover:bg-purple-600 text-white px-2 sm:px-3 py-1 sm:py-2 rounded transition-all duration-200 whitespace-nowrap"
                  >
                    <FontAwesomeIcon icon={faRobot} className="text-xs sm:text-sm" />
                    <span className="hidden sm:inline">Ask AI</span>
                    <span className="sm:hidden text-xs">Ask</span>
                  </button>
                  <button
                    onClick={() => {
                      // Dummy WhatsApp for Contact Seller
                      const sellerPhone = '919876543210'; // Dummy Indian phone number
                      const message = encodeURIComponent(`Hi, I'm interested in your ${product.title}. Can you share more details and pricing?`);
                      window.open(`https://wa.me/${sellerPhone}?text=${message}`, '_blank');
                    }}
                    className="flex items-center justify-start gap-1 sm:gap-2 bg-teal-500 hover:bg-teal-600 text-white px-2 sm:px-3 py-1 sm:py-2 rounded transition-all duration-200 whitespace-nowrap"
                  >
                    <FontAwesomeIcon icon={faPhone} className="text-xs sm:text-sm" />
                    <span className="hidden sm:inline">Contact Seller</span>
                    <span className="sm:hidden text-xs">Contact</span>
                  </button>
                  <button
                    onClick={() => {
                      // Dummy WhatsApp for Contact Seller
                      const sellerPhone = '919834343210'; // Dummy Indian phone number
                      const message = encodeURIComponent(`Hi, I'm interested in ${product.title}. Can you share more details and pricing?`);
                      window.open(`https://wa.me/${sellerPhone}?text=${message}`, '_blank');
                    }}
                    className="flex items-center justify-start gap-1 sm:gap-2 bg-teal-500 hover:bg-teal-600 text-white px-2 sm:px-3 py-1 sm:py-2 rounded transition-all duration-200 whitespace-nowrap"
                  >
                    <FontAwesomeIcon icon={faPhone} className="text-xs sm:text-sm" />
                    <span className="hidden sm:inline">Contact Agent</span>
                    <span className="sm:hidden text-xs">Contact</span>
                  </button>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {nearbyClicked && <MahilaMandiDealsNearby />}
    </div>
  );
};

export default MahilaMandiNearbyDeals;